export default __webpack_public_path__ + "static/media/IMG_0015_6_11zon.ef91991e.jpg";